<template>
  <picture>
    <RevIllustrationSource
      v-if="srcMobile && heightMobile && widthMobile"
      :height="heightMobile"
      :media="mediaMaxWidth"
      :src="srcMobile"
      :width="widthMobile"
    />

    <RevIllustration
      :alt
      class="block w-full object-cover"
      :class="imageClass"
      :fetchpriority
      :height="desktopHeight"
      :loading
      :src
      :width="desktopWidth"
    />
  </picture>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Image } from '@backmarket/http-api/src/api-specs-content/models/image'
import { RevIllustration } from '@ds/components/Illustration'
import { RevIllustrationSource } from '@ds/components/IllustrationSource'

import { Loading, MediaMaxWidth } from './ImageRenderer.constants'

type ImageRendererProps = Image & {
  mediaMaxWidth?: MediaMaxWidth
  loading?: Loading
  imageClass?: string
  // @doc https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/img#fetchpriority
  fetchpriority?: 'high' | 'low' | 'auto'
}

const {
  alt = '',
  mediaMaxWidth = MediaMaxWidth.SM,
  loading = Loading.Eager,
  imageClass = '',
  fetchpriority = 'auto',
  width,
  height,
} = defineProps<ImageRendererProps>()

const desktopWidth = computed(() => width / 2)
const desktopHeight = computed(() => height / 2)
</script>
